/**
 * An abstract navigation engine is some system that tracks
 * application state in a way that can be later resumed
 * as requested by a system _outside_ the application (
 * e.g. the browser or operating system).
 *
 * It is ignorant of URLs even though it may use them as a
 * side effect.
 */
export default class NavigationEngine {
  /**
   * Record the fact that the application into new state that can be returned later (via back button or after a
   * restart)
   *
   * @param  {SerializableObject} newState A serializable descriptor for the application state.
   */
  addNewNavState (newState) {
    throw new Error('abstract implementation');
  }

  /**
   * Change the current recorded application state
   * in-place. The previous state is lost and can't be
   * returned to.
   *
   * @param  {SerializableObject} newState A serializable descriptor for the application state.
   */
  replaceCurrentNavState (newState) {
    throw new Error('abstract implementation');
  }

  /**
   * Manually trigger returning to a previous state,
   * specified by the given offset.
   * @param  {number} offset -1 to go back, +1 to go forward etc.
   */
  returnToState (offset) {
    throw new Error('abstract implementation');
  }


  /**
   * Will call eventListener whenever the underlying system
   * requires that the application state be resumed (e.g.
   * because the back button was used or because of the
   * application has been restarted).
   *
   * The eventListener will be called immediately upon
   * registration if there is state pending
   * initialization (e.g. after a restart). In this case
   * the return value of eventListener is returned.
   *
   * eventListener will be called with the current
   * state, and an integer describing the direction
   * being returned from - e.g. -1 for a "back" action,
   * 1 for "forward" and 0 for a reload.
   *
   * There can only be one handler registered for the
   * application.
   *
   * @param  {function} eventListener
   * @return {*} Return value of eventListener on
   * initial registration.
   */
  onReturnToState (eventListener) {
    throw new Error('abstract implementation');
  }

}



// WEBPACK FOOTER //
// ./lib/rlink-router/NavigationEngine.js